import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { FormattedMessage, useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import * as React from 'react';
import styled from 'styled-components';

type Props = {
    dismissModal: () => void;
    sellerName: string;
    uiError: boolean;
};

const SendSellerConsignmentMessageConfirm = (props: Props) => {
    const { dismissModal, sellerName, uiError } = props;
    const { formatMessage } = useIntl();

    const error = <FormattedMessage id="we_experienced_a_server_error" />;

    return (
        <Container>
            {uiError ? (
                <ConfirmText>{uiError && <ErrorMessage>{error}</ErrorMessage>}</ConfirmText>
            ) : (
                <ConfirmText>
                    <FormattedMessage
                        id="consignment_review_notice"
                        values={{ sellerName }}
                    />
                </ConfirmText>
            )}
            <ButtonContainer>
                <StyledButton onClick={dismissModal}>{formatMessage({ id: 'keep_browsing' })}</StyledButton>
            </ButtonContainer>
        </Container>
    );
};

export default React.memo<Props>(SendSellerConsignmentMessageConfirm);

const Container = styled(BodyPrimary)`
    display: flex;
    flex-direction: column;
    align-items: center;
    font-style: normal;
    text-align: left;
    padding-bottom: 50px;
    padding-top: 20px;
`;

const ConfirmText = styled.div`
    margin-bottom: 32px;
    padding: 0 64px;
    text-align: center;

    @media (max-width: 450px) {
        padding: 0 15px;
    }
`;

const ErrorMessage = styled.span`
    color: ${({ theme }) => theme.colors.red100} !important;
    font-size: 14px;
`;

const ButtonContainer = styled.div`
    width: calc(100% - 64px);
`;

const StyledButton = styled(Button)`
    margin: 0 auto;
    width: 264px;
    @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        width: 100%;
    }
`;
